import { useControllerData } from '../../contexts/main/controllerContext';
import { getParticipantIdFromInitialProps } from '../../selectors/participant/getParticipantId';

export const useParticipantId = () => {
  const data = useControllerData();
  return getParticipantIdFromInitialProps(data);
};
